































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Register extends Vue {
    
    private unitTree = [];
    private selUnit = [0];
    private registerForm = {
        phone: "",
        verify: "",
        nickName: "",
        password: "",
        duty: "",
        unitId: null as null | number,
    };
    private rules = {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },],
        nickName: [{ required: true, message: '请输入用户昵称', trigger: 'blur' }],
        verify: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        unitId: [{ required: true, message: '请输入单位', trigger: 'blur' }]
    };

    created() {
        this.reloadTree();
    }

    // 加载机构树
    reloadTree() {
        this.$apis.getAllUnitTree()
            .then((res: any) => {
                this.unitTree = res.data;
            });
    }

    onUnitChange(value: number[]) {
        this.registerForm.unitId = value[value.length - 1];
        console.log(this.registerForm.unitId)
    }

    onVerify() {
        this.$apis.getVerify(this.registerForm.phone)
            .then((res: any) => {
                this.$message({
                    type: 'success',
                    message: '验证码已发送，请注意查收!'
                });
            });
    }

    onRegister() {
        (this.$refs.registerForm as HTMLFormElement).validate((valid: boolean) => {
            if (valid) {
                this.$apis.postRegister(this.registerForm)
                    .then((res: any) => {
                        this.$message({
                            type: 'success',
                            message: '已注册成功，请联系管理员审核!'
                        });
                    });
            }
        });
    }

    onLogin() {
        this.$router.push("/login");
    }
}
